// Add classed scrolled when window is scrolled.


$(document).ready(function() {

    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 1) {
            $("body").addClass("scrolled_px");
        } else {
            $("body").removeClass("scrolled_px");
        }
		
		if (scroll >= 40) {
            $("body").addClass("scrolled");
        } else {
            $("body").removeClass("scrolled");
        }

        if (!$('body').is('.leaderboard-on') || scroll > 91) {
            $('#navpos').removeClass("navbar-absolute-top");
            $('#navpos').addClass("navbar-fixed-top");
        }
        else {
            $('#navpos').removeClass("navbar-fixed-top");
            $('#navpos').addClass("navbar-absolute-top");
        }

    });
});

AddPageSwapTriggerSwup(function() {
    if($('#swup-header').find('.top-leaderboard').is('.top-leaderboard')) {
        $('body').addClass('leaderboard-on');
        $('body').removeClass('leaderboard-off');
    }
    else {
        $('body').removeClass('leaderboard-on');
        $('body').addClass('leaderboard-off');
    }

    if($('#swup-header').find('.top-leaderboard-mobile-formaat').is('.top-leaderboard-mobile-formaat')) {
        $('body').addClass('leaderboard-mobile-on');
        $('body').removeClass('leaderboard-mobile-off');
    }
    else {
        $('body').removeClass('leaderboard-mobile-on');
        $('body').addClass('leaderboard-mobile-off');
    }
});